module.exports = __webpack_public_path__ + "static/media/guoge.b5b05f2.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/music/guoge.mp3
// module id = hWs6
// module chunks = 1